/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.06.17.
 */

import React from "react";
import PropTypes from "prop-types";

class Pagination extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        showPages: PropTypes.number,
        pageSize: PropTypes.number.isRequired,
        recordCount: PropTypes.number,
        /**
         * First record number (zero-based!)
         */
        firstRecord: PropTypes.number,
        /**
         * onGotoRecord(recordNumber)
         */
        onGotoRecord: PropTypes.func.isRequired
    };

    static defaultProps = {
        showPages: 5,
        recordCount: 0,
        firstRecord: 0
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    onClickPage(i) {
        if (this.props.onGotoRecord) this.props.onGotoRecord((i-1)*this.props.pageSize);
    }

    onClickRecord(i) {
        if (this.props.onGotoRecord) this.props.onGotoRecord(i);
    }

    renderPageLinks(firstPage, lastPage, currentPage) {

        let pages = [];
        for (let i = firstPage; i <= lastPage; i++) {
            pages.push(<li key={i} className={i == currentPage ? "active" : ""}><a href="#" onClick={() => this.onClickPage(i)}>{i}</a></li>);
        }
        return pages;
    }

    render() {
        if (!this.props.recordCount || !this.props.pageSize) return null;
        if (this.props.firstRecord == 0 && this.props.recordCount <= this.props.pageSize) return null;

        let prevClassName = (this.props.firstRecord > 0 ? "" : "disabled");
        let nextClassName = (this.props.firstRecord + this.props.pageSize < this.props.recordCount ? "" : "disabled");

        let pageCount = Math.floor(this.props.recordCount / this.props.pageSize);
        if (this.props.recordCount % this.props.pageSize != 0) pageCount++;

        let currentPage = Math.floor(this.props.firstRecord / this.props.pageSize) + 1;
        if (this.props.firstRecord % this.props.pageSize != 0) currentPage++;

        let firstPage = currentPage - Math.floor(this.props.showPages/2);
        if (firstPage < 1) firstPage = 1;

        let lastPage = firstPage + this.props.showPages - 1;
        if (lastPage > pageCount) {
            lastPage = pageCount;
            if (firstPage > 1) {
                firstPage = lastPage - this.props.showPages + 1;
                if (firstPage < 1) firstPage = 1;
            }
        }

        let prevIdx = this.props.firstRecord - this.props.pageSize;
        if (prevIdx < 0) prevIdx = 0;
        let nextIdx = this.props.firstRecord + this.props.pageSize;
        if (nextIdx >= this.props.recordCount) {
            nextIdx = this.props.recordCount - this.props.pageSize;
            if (nextIdx < 0) nextIdx = 0;
        }
        let lastIdx = this.props.recordCount - this.props.pageSize;
        if (lastIdx < 0) lastIdx = 0;

        return (
            <nav aria-label="Page navigation">
                <ul className={"pagination" + (this.props.className ? " " + this.props.className : "")}>
                    <li className={prevClassName}><a href="#" onClick={() => this.onClickRecord(0)} aria-label="First"><span className="fa fa-angle-double-left" aria-hidden="true"></span></a></li>
                    <li className={prevClassName}><a href="#" onClick={() => this.onClickRecord(prevIdx)} aria-label="Previous"><span className="fa fa-angle-left" aria-hidden="true"></span></a></li>
                    {this.renderPageLinks(firstPage, lastPage, currentPage)}
                    <li className={nextClassName}><a href="#" onClick={() => this.onClickRecord(nextIdx)} aria-label="Next"><span className="fa fa-angle-right" aria-hidden="true"></span></a></li>
                    <li className={nextClassName}><a href="#" onClick={() => this.onClickRecord(lastIdx)} aria-label="Last"><span className="fa fa-angle-double-right" aria-hidden="true"></span></a></li>
                </ul>
            </nav>
        );
    }
}

export default Pagination;
